import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CookieService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  setCookie(name: string, value: string, days: number = 30): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(
      value
    )};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name: string): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;

    const match = document.cookie.match(
      new RegExp(
        '(?:^|; )' + name.replace(/([$?*|{}\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'
      )
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  hasCookie(name: string): boolean {
    return this.getCookie(name) !== null;
  }

  deleteCookie(name: string): void {
    if (!isPlatformBrowser(this.platformId)) return;
    document.cookie = `${name}=; Max-Age=0; path=/`;
  }
}
